export const domainList = [
    "deseo.tech",
    "localhost:3000",
    "localhost:3001",
    "uat.deseo.tech",
    "uat.localhost:3000"
]